var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 4.5C8.25 6.57105 6.57105 8.25 4.5 8.25C2.42893 8.25 0.75 6.57105 0.75 4.5C0.75 2.42893 2.42893 0.75 4.5 0.75C6.57105 0.75 8.25 2.42893 8.25 4.5ZM4.875 3C4.875 3.20711 4.70711 3.375 4.5 3.375C4.29289 3.375 4.125 3.20711 4.125 3C4.125 2.7929 4.29289 2.625 4.5 2.625C4.70711 2.625 4.875 2.7929 4.875 3ZM4.5 3.75C4.29289 3.75 4.125 3.91789 4.125 4.125V6C4.125 6.20711 4.29289 6.375 4.5 6.375C4.70711 6.375 4.875 6.20711 4.875 6V4.125C4.875 3.91789 4.70711 3.75 4.5 3.75Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "dist/media/Info.e4c60020.svg";
export { ForwardRef as ReactComponent };